import {AfterViewInit, Directive, Input, OnDestroy} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {Subscription} from 'rxjs';

export type AllowedInputSymbols = 'spaces' | 'tags' | 'slashes' | 'letters' | 'underscore' | 'numbers';

@Directive({
  selector: '[allowedSymbols]'
})
export class AllowedSymbolsDirective implements AfterViewInit, OnDestroy {
  @Input() controlRef: AbstractControl;
  @Input() allowed: AllowedInputSymbols[] = [];
  private valueChangesSubscription: Subscription;

  public ngAfterViewInit(): void {
    this.valueChangesSubscription = this.controlRef.valueChanges
      .subscribe((): void => this.filterByAllowed());
  }

  public ngOnDestroy(): void {
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
  }

  private filterByAllowed(): void {
    const value: string | null = this.controlRef.value;
    if (this.allowed.length === 0) {
      return;
    }

    let newValue: string = value;
    const isSpacesAllowed: boolean = this.allowed.includes('spaces');
    if (isSpacesAllowed === false) {
      newValue = newValue.replace(/\s/g, '');
    }

    const isTagsAllowed: boolean = this.allowed.includes('tags');
    if (isTagsAllowed === false) {
      newValue = newValue.replace(/(<([^>]+)>)/gi, '');
    }

    const isSlashesAllowed: boolean = this.allowed.includes('slashes');
    if (isSlashesAllowed === false) {
      newValue = newValue.replace(/\\/g, '');
    }

    const isLettersAllowed: boolean = this.allowed.includes('letters');
    if (isLettersAllowed === false) {
      newValue = newValue.replace(/\p{L}/gu, '');
    } else {
      newValue = newValue.replace(/[^a-zA-Z0-9\s_-]+/g, '');
    }

    const isUnderscoreAllowed: boolean = this.allowed.includes('underscore');
    if (isUnderscoreAllowed === false) {
      newValue = newValue.replace(/_/g, '');
    }

    const isNumbersAllowed: boolean = this.allowed.includes('numbers');
    if (isNumbersAllowed === false) {
      newValue = newValue.replace(/[0-9]/g, '');
    }

    if (newValue !== value) {
      this.controlRef.setValue(newValue, {emitEvent: false});
    }
  }
}
